import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=01279081&scoped=true&"
import script from "./EndScreen.vue?vue&type=script&lang=ts&"
export * from "./EndScreen.vue?vue&type=script&lang=ts&"
import style0 from "./EndScreen.vue?vue&type=style&index=0&id=01279081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01279081",
  null
  
)

export default component.exports